import React, { useState } from "react";
import ChatIcon from '@mui/icons-material/Chat';

import {
    FloatingButton,
    ChatWindow,
    ChatBody,
    ChatIframe,
} from "../styles/ChatWidget.elements";
import { useTenantContext } from "../../tenant/TenantContext";
import { useUserContext } from "../../user/infrastructure/UserContext";

const normalizeCodigoCliente = (value) => {
    if (value === null || value === undefined) return null;
    const s = String(value).trim();
    return s ? s : null;
};

const readCookie = (name) => {
    if (typeof document === "undefined") return null;
    const cookies = document.cookie ? document.cookie.split("; ") : [];
    for (const c of cookies) {
        const [k, ...rest] = c.split("=");
        if (k === name) return decodeURIComponent(rest.join("="));
    }
    return null;
};

const getCodigoCliente = () => {
    if (typeof window === "undefined") return null;

    const q = new URLSearchParams(window.location.search).get("codigo_cliente");
    if (q && q.trim()) return q.trim();

    if (window.__LV_CODIGO_CLIENTE) return String(window.__LV_CODIGO_CLIENTE).trim();

    const ck = readCookie("codigo_cliente");
    if (ck && ck.trim()) return ck.trim();

    const ls = window.localStorage?.getItem("codigo_cliente");
    if (ls && ls.trim()) return ls.trim();

    return null;
};

const buildChatSrc = (baseUrl, codigoCliente) => {
    try {
        const url = new URL(baseUrl);
        if (codigoCliente) url.searchParams.set("codigo_cliente", codigoCliente);
        return url.toString();
    } catch {

        if (!codigoCliente) return baseUrl;
        const sep = baseUrl.includes("?") ? "&" : "?";
        return `${baseUrl}${sep}codigo_cliente=${encodeURIComponent(codigoCliente)}`;
    }
};

const ChatWidget = () => {
    const [isOpen, setIsOpen] = useState(false);
    const tenant = useTenantContext();
    const user = useUserContext();
    const primaryColor = tenant?.primaryColor || "#2563eb";
    const chatConfig = tenant?.chat;

    const enabled = chatConfig?.enabled;
    const chatUrl = chatConfig?.url;

    if (!enabled || !chatUrl) return null;

    const toggleOpen = () => setIsOpen((prev) => !prev);

    const codigoCliente = normalizeCodigoCliente(user?.code) || getCodigoCliente();
    const iframeSrc = buildChatSrc(chatUrl, codigoCliente);

    return (
        <>
            <ChatWindow $isOpen={isOpen}>
                <ChatBody>
                    <ChatIframe
                        src={iframeSrc}
                        title="Chat"
                        allow="clipboard-read; clipboard-write"
                    />
                </ChatBody>
            </ChatWindow>

            <FloatingButton onClick={toggleOpen} $primaryColor={primaryColor}>
                <ChatIcon style={{ fontSize: 28 }} />
            </FloatingButton>
        </>
    );
};

export default ChatWidget;
